import React from 'react';
import { Link } from "react-router-dom";
import "./surfing.css";
import { FaWater, FaWaveSquare, FaMapMarkedAlt } from "react-icons/fa";

function Surfing() {
  const surfingSpots = [
    { name: "Arugam Bay", highlight: "World-famous surf break", image: "/aru.jpg" },
    { name: "Weligama", highlight: "Perfect for beginners and pros", image: "/wali.jpg" },
    { name: "Hikkaduwa", highlight: "Vibrant waves and coral reefs", image: "/hikka.jpg" },
    { name: "Mirissa", highlight: "Relaxed beach with surfable waves", image: "/mirissa.jpg" },
    { name: "Unawatuna", highlight: "Scenic beach with moderate waves", image: "/una.jpeg" },
    { name: "Matara", highlight: "Untouched surf destination", image: "/matara.jpeg" },
  ];

  return (
    <div className="bird-page">
      {/* Banner */}
      <div className="banner-section">
        <img src="/surfing.webp" alt="Surfing Adventure" className="banner-image" />
        <div className="banner-content">
          <h1 className="banner-title"><span><b>Surfing</b></span> Adventures</h1>
          <div className="banner-description">
            <p>Ride the waves along Sri Lanka’s pristine coastline. Whether you’re a beginner or a seasoned surfer, our waters offer the perfect conditions year-round.</p>
            <Link to="/booking"><button className="book-now-btn">Book Your Surf Trip</button></Link>
          </div>
        </div>
      </div>

      {/* Locations */}
      <div className="wildlife-areas-section">
        <h2 className="section-title">Best Surfing Spots</h2>
        <p className="section-subtitle">Catch the perfect wave</p>
        <div className="wildlife-areas-grid">
          {surfingSpots.map((spot, i) => (
            <div className="wildlife-area-card" key={i}>
              <div className="area-image-container">
                <img src={spot.image} alt={spot.name} className="area-image" loading="lazy" />
                <div className="area-overlay"></div>
              </div>
              <div className="area-info">
                <h3>{spot.name}</h3>
                <p>{spot.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Cards */}
      <section className="info-section">
        <div className="info-card"><FaWater className="icon" /><h3 className="desc-heading">Surf Lessons</h3><p className="desc-para">Learn from experienced local surfers.</p></div>
        <div className="info-card"><FaWaveSquare className="icon" /><h3 className="desc-heading">Perfect Waves</h3><p className="desc-para">Find the ideal wave for your skill level.</p></div>
        <div className="info-card"><FaMapMarkedAlt className="icon" /><h3 className="desc-heading">Top Locations</h3><p className="desc-para">Explore the best surf beaches in Sri Lanka.</p></div>
      </section>

      {/* Quote */}
      <section className="quote-section">
        <blockquote>"You can’t stop the waves, but you can learn to surf."</blockquote>
        <cite>— Jon Kabat-Zinn</cite>
      </section>
    </div>
  );
}

export default Surfing;
